"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TileView = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var TileView = function TileView() {
  return react_1.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66667 0H6.66667C8.13943 0 9.33333 1.19391 9.33333 2.66667V6.66667C9.33333 8.13943 8.13943 9.33333 6.66667 9.33333H2.66667C1.19391 9.33333 0 8.13943 0 6.66667V2.66667C0 1.19391 1.19391 0 2.66667 0ZM2.66666 6.66655H6.66667V2.66655H2.66666V6.66655ZM21.3333 0H17.3333C15.8606 0 14.6667 1.19391 14.6667 2.66667V6.66667C14.6667 8.13943 15.8606 9.33333 17.3333 9.33333H21.3333C22.8061 9.33333 24 8.13943 24 6.66667V2.66667C24 1.19391 22.8061 0 21.3333 0ZM17.3333 6.66655H21.3333V2.66655H17.3333V6.66655ZM9.33333 17.3332C9.33333 15.8605 8.13943 14.6665 6.66667 14.6665H2.66667C1.19391 14.6665 0 15.8605 0 17.3332V21.3332C0 22.806 1.19391 23.9999 2.66667 23.9999H6.66667C8.13943 23.9999 9.33333 22.806 9.33333 21.3332V17.3332ZM2.66666 21.3331H6.66667V17.3331H2.66666V21.3331ZM21.3333 14.6665H17.3333C15.8606 14.6665 14.6667 15.8605 14.6667 17.3332V21.3332C14.6667 22.806 15.8606 23.9999 17.3333 23.9999H21.3333C22.8061 23.9999 24 22.806 24 21.3332V17.3332C24 15.8605 22.8061 14.6665 21.3333 14.6665ZM17.3333 21.3331H21.3333V17.3331H17.3333V21.3331Z",
    fill: "currentColor"
  });
};

exports.TileView = TileView;